<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-start>
      <v-flex px-md-5 xs12 text-left>
        <span style="color: #000; font-size: 22px; font-family: poppinsbold"
          >{{ $route.query.shop }}'s Products
        </span>
      </v-flex>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs12 sm6 md3 pa-5>
            <v-autocomplete
              outlined
              dense
              color="#8d8d8d"
              placeholder="Category"
              v-model="categoryFilter"
              :items="categories"
              item-text="name"
              item-value="_id"
              item-color="#FF1313"
              hide-details
              clearable
              class="text-left"
              label="Category"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md3 pa-5>
            <v-autocomplete
              outlined
              dense
              color="#8d8d8d"
              placeholder="Product Type"
              v-model="productType"
              :items="productTypes"
              item-text="name"
              item-value="value"
              item-color="#FF1313"
              hide-details
              clearable
              class="text-left"
              label="Product Type"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md3 pa-5>
            <v-select
              v-model="productStatus"
              :items="productStatusList"
              item-text="name"
              item-value="value"
              item-color="#8d8d8d"
              color="#8d8d8d"
              outlined
              dense
              label="Status"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 v-if="products && totalCount > 0">
        <v-layout wrap px-md-3 pb-3>
          <v-flex xs6 sm6 md3 v-for="(item, i) in products" :key="i">
            <v-card tile :elevation="0" class="ma-3">
              <v-layout wrap justify-center text-center px-3 pb-6 pt-2>
                <v-flex xs12 pb-2 v-if="item.photo">
                  <v-img
                    contain
                    :style="
                      $vuetify.breakpoint.name == 'xs'
                        ? 'height:150px'
                        : 'height:250px'
                    "
                    :src="mediaURL + item.photo"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color=" #FDAC53"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex xs12 pb-2 v-else>
                  <v-img
                    height="250"
                    :src="require('./../../../assets/images/no-image.png')"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color=" #FDAC53"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex style="height: 80px" xs12 text-center>
                  <v-layout wrap justify-center>
                    <v-card flat>
                      <v-flex style="font-family: poppinsbold" xs12>
                        {{ item.name }}
                      </v-flex>

                      <v-flex xs12 pt-1 v-if="item.discount > 0">
                        <span style="font-weight: bold">
                          Rs. {{ item.offerPrice }}
                        </span>
                        <del
                          ><span style="font-weight: bold">
                            Rs. {{ item.price }}
                          </span></del
                        >
                      </v-flex>
                      <v-flex xs12 pt-1 v-else>
                        <span style="font-weight: bold">
                          Rs. {{ item.offerPrice }}
                        </span>
                      </v-flex>
                    </v-card>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md6 pt-2 pr-0 pr-sm-2>
                  <v-btn
                    width="100%"
                    small
                    depressed
                    outlined
                    color="success"
                    :to="
                      'ProductInfo?product=' +
                      item._id +
                      '&shop=' +
                      $route.query.shop
                    "
                    ><span>View</span></v-btn
                  >
                </v-flex>
                <v-flex xs12 sm12 md6 pt-2 pl-0 pl-sm-2>
                  <v-btn
                    width="100%"
                    @click="(deleteData = item), (deleteDialog = true)"
                    small
                    depressed
                    outlined
                    color="red"
                    ><span>Delete</span></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-if="pages > 1" wrap justify-center>
          <v-flex align-self-center>
            <div class="pt-2">
              <v-pagination
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                :length="pages"
                :total-visible="7"
                v-model="currentPage"
                color="#FDAC53"
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pa-16 v-else>
        <span class="PM">No Products availble in this category!</span>
      </v-flex>
    </v-layout>
    <v-dialog v-model="deleteDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title
          >Are you sure you want to remove this product</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      ServerError: false,
      timeout: 5000,
      msg: null,
      products: [],
      currentPage: 1,
      pages: 0,
      totalCount: 0,
      deleteDialog: false,
      deleteData: {},
      productType: null,
      productTypes: [],
      productStatusList: [
        { name: "Active", value: "Active" },
        { name: "Inactive", value: "Inactive" },
        { name: "All", value: null },
      ],
      productStatus: null,
      categoryFilter: null,
      categories: [],
      prevRoute: localStorage.getItem("LS_ROUTE_KEY"),
    };
  },
  computed: {
    pageFilters1() {
      if (this.$store.state.sellerProductPageFilters) {
        return this.$store.state.sellerProductPageFilters;
      } else {
        return {};
      }
    },
    pageFilters2() {
      return {
        type: this.$route.name,
        currentPage: this.currentPage,
        category: this.categoryFilter,
        productType: this.productType,
        status: this.productStatus,
      };
    },
  },
  beforeMount() {
    this.getCategories();
    this.getProductTypes();
    if (this.$route.query.category) {
      this.categoryFilter = this.$route.query.category;
      this.getData();
    } else if (this.$route.query.productType) {
      this.productType = this.$route.query.productType;
      this.getData();
    } else {
      if (
        this.pageFilters1.category == null &&
        this.pageFilters1.productType == null &&
        this.pageFilters1.status == null
      )
        this.getData();
    }
    if (this.prevRoute == "/ProductInfo" || this.prevRoute == "/editProduct") {
      this.categoryFilter = this.pageFilters1.category;
      this.productType = this.pageFilters1.productType;
      this.currentPage = this.pageFilters1.currentPage;
      this.productStatus = this.pageFilters1.status;
    }
  },
  watch: {
    currentPage() {
      this.getData();
    },
    categoryFilter() {
        // if (this.$store.state.sellerProductPageFilters) {
        // if (!this.$store.state.sellerProductPageFilters.currentPage) {
          if (this.currentPage > 1) this.currentPage = 1;
        // }
      // }
      this.getData();
    },
    productType() {
      this.getData();
    },
    productStatus() {
      this.getData();
    },
    pageFilters2: {
      handler(val) {
        // alert("hii")
        if (val) this.storeUpdation();
      },
      deep: true,
    },
  },
  methods: {
    storeUpdation() {
      // alert("hii")
      this.$store.commit("sellerProductPageFilters", this.pageFilters2);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: this.$route.query.seller,
          categoryId: this.categoryFilter,
          type: this.productType,
          status: this.productStatus,
          limit: 20,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.totalLength;
            this.pages = response.data.totalPages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getCategories() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/category/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.categories = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
    getProductTypes() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/type/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.productTypes = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },

    deleteItem() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/delete/" + this.deleteData._id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.getData();
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.getData();

            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      // var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
  },
};
</script>
<style>
.head {
  font-family: poppinsregular;
  font-size: 14px;
}
.content {
  font-family: poppinsbold;
  font-size: 13px;
}
</style>